import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import type { AppDispatch } from "store";
import { StarIcon } from "shared/ui";
import { addIndicator, toggleFavoriteIndicator, selectFavoriteIndicators } from "../../model";
import { INDICATORS } from "../config";

import styles from "../select-indicators/SelectIndicators.module.css";

export const AllIndicatorsList: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const favorites = useSelector(selectFavoriteIndicators);

  return (
    <ul className={styles.list}>
      {INDICATORS.map((indicator) => {
        const isFavorite = favorites.includes(indicator.name);
        return (
          <li key={indicator.name} className={styles.item}>
            <button
              className={styles.starBtn}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(toggleFavoriteIndicator(indicator.name));
              }}
              title={isFavorite ? "Remove from favorites" : "Add to favorites"}
            >
              <StarIcon
                className={styles.starIcon}
                fill={isFavorite ? "#F89706" : "none"}
              />
            </button>
            <span
              className={styles.itemLabel}
              onClick={() => dispatch(addIndicator(indicator.name))}
            >
              {indicator.label}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
